/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import MESSANGER from '../BaseComponent/MESSANGER'
import $ from 'jquery'
import InputMask from 'react-input-mask'
import TMS from '../BaseComponent/TMS'
import Sort from '../Pagination/Sort'
import {accounting} from 'accounting'
import Pageing from '../Pagination/pageing'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderGrid from '../Pagination/HeaderGrid'
import Loader from '../loaders/loader'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import RETAIL from '../BaseComponent/RETAIL'

class ReportOil extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      printInfo: [],
      excelReport: [],
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      Drivers: [],
      driverId: '',
      cars: [],
      carId: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تحویل گیرنده',
          value: 'RecieverLastName',
          sorted: true,
          direction: null,
          sortable: false
        },
        {
          name: 'نوع تحویل گیرنده',
          value: 'RecieverType',
          sorted: true,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره فاکتور',
          value: 'SerialNo',
          sorted: true,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل تحویل گیرنده',
          value: 'RecieverMobile',
          sorted: true,
          direction: null,
          sortable: false
        },
        {
          name: 'آدرس تحویل گیرنده',
          value: 'RecieverAddress',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'رساننده',
          value: ' driverName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پلاک',
          value: ' PlaqueId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مبلغ کل',
          value: ' TotalAmountPayment',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تعداد ارسال',
          value: ' sentCount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت ثبت',
          value: ' successCount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ثبت',
          value: ' TotalAmountPayment',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getAll = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_OIL_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          if (!exportStatus) {
            $('.showBaseTable').fadeIn()
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false,
              buttonClicked: true
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              excelReport: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false,
              buttonClicked: true
            })
          }
        } else {
          this.setState({
            list: [],
            printInfo: [],
            excelReport: [],
            countAll: '',
            loading: false
          })
          $('.showBaseTable').fadeOut()
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {
        params: {
          oilSupport: true
        }
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {})

    http
      .get(`car/manage/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          var cars = response.data.object
          for (let i = 0; i < cars.length; i++) {
            cars[i]['value'] = cars[i].carId
            cars[i]['label'] = ' کد ' + cars[i].code + ' - ' + cars[i].plate
          }

          this.setState({
            cars
          })
        }
      })
      .catch((error) => {})
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }
  getvalueCars = (carId) => {
    this.setState({
      carId
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAll(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAll(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAll(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let planDateMin = this.state.fromDate
    let planDateMax = this.state.toDate
    let invoiceNum = document.getElementById('invoiceNum').value.trim()
    let sent = document.getElementById('sent').value.trim()
    let success = document.getElementById('success').value.trim()
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let carId = this.state.carId == null || this.state.carId == '' ? '' : this.state.carId.carId
    // let carId = document.getElementById('carId').value

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (planDateMin !== '') {
      filter.planDateMin = planDateMin
    }
    if (planDateMax !== '') {
      filter.planDateMax = planDateMax
    }
    if (invoiceNum !== '') {
      filter.invoiceNum = invoiceNum
    }
    if (driverId !== '') {
      filter.driverId = driverId
    }
    if (success !== '') {
      filter.success = success
    }
    if (sent !== '') {
      filter.sent = sent
    }
    if (carId !== '') {
      filter.carId = carId
    }
    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getAll(false)
        }
      )
    }
    // sessionStorage.setItem("params", `name=${name}&bank=${bank}`);
  }
  batch = () => {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState({
        batchModal: true
      })
    }
  }
  setFinalBatch = () => {
    let filter = this.createFilter(false)
    delete filter.export
    delete filter.pageSize
    delete filter.pageNumber

    this.setState({
      loading: true
    })
    http
      .get(`public/retail/report/oil/batch`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            batchModal: false,
            loading: false
          })
          this.getAll(false)
          message.success('عملیات با موفقیت انجام شد')
        } else {
          this.setState({
            batchModal: false,
            loading: false
          })
        }
      })
      .catch((err) => {
        this.setState({
          batchModal: false,
          loading: false
        })
      })
  }

  exportExcel = () => {
    let filter = this.createFilter()
    filter.export = true
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_OIL_MASTER}`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state
          excelReport.forEach((item) => {
            item.bol.fullName = item.bol.RecieverName + '  ' + item.bol.RecieverLastName
            item.bol.RecieverType = this.statusReciever(item.bol.RecieverType)
            item.bol.plateCar = 'ایران ' + item.bol.PlaqueSN + ' - ' + item.bol.PlaqueId
            if (item.successCount !== 0) {
              item.successCount = 'ارسال شده'
            } else {
              item.successCount = 'ارسال نشده'
            }
          })
          this._export.save(this.state.excelReport)
        }
        // else {
        //     $('.showBaseTable,.print').fadeOut();
        //     // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        // }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getPrintInfo = () => {
    this.getAll(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  statusReciever = (type) => {
    if (type === 1) {
      return 'حقیقی'
    } else if (type === 2) {
      return 'حقوقی'
    } else {
      return '-'
    }
  }

  setWebServiceOil = (deliveryPackId) => {
    this.setState({
      deliveryPackId,
      webServiceModal: true
    })
  }

  setFinalWebService = () => {
    let {deliveryPackId} = this.state
    this.setState({
      loading: true
    })
    http
      .get(`public/retail/report/oil/webService`, {
        params: {
          deliveryPackId
        }
      })
      .then((res) => {
        if (res.data.error === null) {
          if (res.data.object.ErrCode !== null) {
            message.error(res.data.object.ErrDesc)
            this.setState({
              webServiceModal: false,
              loading: false
            })
          } else {
            this.getAll(false)
            this.setState({
              webServiceModal: false,
              loading: false
            })
            message.success('عملیات با موفقیت انجام شد')
          }
        }
      })
      .catch((err) => {
        this.setState({
          loading: false
        })
      })
  }

  render() {
    let {pageNumber, pageSize} = this.state
    let printCol = [
      'ردیف',
      'تحویل گیرنده',
      'نوع تحویل گیرنده',
      'شماره فاکتور',
      'موبایل تحویل گیرنده',
      'آدرس',
      'پلاک',
      'مبلغ کل',
      'تعداد ارسال',
      'وضعیت ثبت'
    ]
    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش سهمیه بنزین"
              headerColSpan={10}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={3}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.bol.RecieverName + '  ' + item.bol.RecieverLastName}</td>
                  <td>{this.statusReciever(item.bol.RecieverType)}</td>
                  <td>
                    <Link target="_blank" to={`/baskets?invoiceNum=${item.invoiceNum}`}>
                      {item.invoiceNum}
                    </Link>
                  </td>
                  <td>{item.bol.RecieverMobile}</td>
                  <td style={{maxWidth: '150px'}}>{item.bol.RecieverAddress}</td>
                  <td>
                    {`ایران ${item.bol.PlaqueSN}`} - {` ${item.bol.PlaqueId} `}
                  </td>
                  <td className="text-left">{accounting.formatMoney(item.bol.TotalAmountPayment, '', ',')} ریال</td>
                  <td className="">{item.sentCount}</td>
                  <td className="">
                    {item.successCount === 0 ? (
                      <img width={'20px'} src={require('../../image/ignor.svg')} />
                    ) : (
                      <img width={'20px'} src={require('../../image/confirm.svg')} />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش سهمیه بنزین.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'fullName'}
                field={'bol.fullName'}
                title={'تحویل گیرنده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'RecieverType'}
                field={'bol.RecieverType'}
                title={'نوع تحویل گیرنده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceNum'}
                field={'invoiceNum'}
                title={'شماره فاکتور'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'RecieverMobile'}
                field={'bol.RecieverMobile'}
                title={'موبایل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'RecieverAddress'}
                field={'bol.RecieverAddress'}
                title={'آدرس'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'plateCar'}
                field={'bol.plateCar'}
                title={'پلاک خودرو'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'TotalAmountPayment'}
                field={'bol.TotalAmountPayment'}
                title={'مبلغ کل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sentCount'}
                field={'sentCount'}
                title={'تعداد ارسال'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'successCount'}
                field={'successCount'}
                title={'وضعیت ثبت'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>سهمیه بنزین</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
                <button className="printButton" style={{width: '130px'}} onClick={this.batch}>
                  ارسال دسته جمعی
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent selectComponent">
                  <SearchableCombo
                    options={this.state.cars}
                    getValueCombo={this.getvalueCars}
                    lableText="خودرو"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
                <div className="formComponent">
                  <label>وضعیت ارسال:</label>
                  <select className="form-control mb-2 mr-sm-2" id="sent">
                    <option value="">-------</option>
                    <option value={0}>ارسال نشده</option>
                    <option value={1}>ارسال شده</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>وضعیت ثبت:</label>
                  <select className="form-control mb-2 mr-sm-2" id="success">
                    <option value="">-------</option>
                    <option value={0}>ثبت نشده</option>
                    <option value={1}>ثبت شده</option>
                  </select>
                </div>

                {/*<div className='formComponent'>*/}
                {/*    <label className="mb-2 mr-sm-2">خودرو</label>*/}
                {/*    <select className="form-control mb-2 mr-sm-2" id="carId">*/}
                {/*        <option value=''>-------</option>*/}
                {/*        {this.state.cars.map((car, index) => (*/}
                {/*            <option value={car.carId}>{car.name + ' ' + car.plate + ' کد خودرو ' + car.code}</option>*/}
                {/*        ))}*/}
                {/*    </select>*/}
                {/*</div>*/}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.bol.RecieverName + '  ' + item.bol.RecieverLastName}</td>
                      <td>{this.statusReciever(item.bol.RecieverType)}</td>
                      <td>
                        <Link target="_blank" to={`/baskets?invoiceNum=${item.invoiceNum}`}>
                          {item.invoiceNum}
                        </Link>
                      </td>
                      <td>{item.bol.RecieverMobile}</td>
                      <td style={{maxWidth: '150px'}}>{item.bol.RecieverAddress}</td>
                      <td>{item.driverName}</td>
                      <td>
                        {`ایران ${item.bol.PlaqueSN}`} - {` ${item.bol.PlaqueId} `}
                      </td>
                      <td className="text-left">{accounting.formatMoney(item.bol.TotalAmountPayment, '', ',')} ریال</td>
                      <td className="">{item.sentCount}</td>
                      <td className="">
                        {item.successCount === 0 ? (
                          <img width={'20px'} src={require('../../image/ignor.svg')} />
                        ) : (
                          <img width={'20px'} src={require('../../image/confirm.svg')} />
                        )}
                      </td>
                      <td className="text-center">
                        <span
                          onClick={() => this.setWebServiceOil(item.deliveryPackId)}
                          title="ثبت درخواست بنزین"
                          className="bg-transparent"
                          style={{cursor: 'pointer'}}
                        >
                          <img src={require('../../image/tap.svg')} />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
                {/*<Page defaultCurrent={1} total={this.state.countAll}*/}
                {/*      onResultFetched={this.onResultFetched.bind(this)} url={TMS.TMS_MANAGE_BASE_SECTION_REPORT}/>*/}
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.webServiceModal} toggle={() => this.setState({webServiceModal: false})} size="sm">
          <ModalBody>
            <div className="text-center font-weight-bold">آیا از انجام درخواست اطمینان دارید؟؟</div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.setFinalWebService}>
              تایید
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({webServiceModal: false})}>
              انصراف
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.batchModal} toggle={() => this.setState({batchModal: false})} size="sm">
          <ModalBody>
            <div className="text-center font-weight-bold">آیا از انجام درخواست اطمینان دارید؟؟</div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.setFinalBatch}>
              تایید
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({batchModal: false})}>
              انصراف
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReportOil
